function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 2.25a.75.75 0 00-.75.75v26c0 .414.336.75.75.75h8a.75.75 0 000-1.5H4.75V3.75h2.5v.668a1.75 1.75 0 101.5 0V3.75h3.5v.668a1.75 1.75 0 101.5 0V3.75h3.5v.668a1.75 1.75 0 101.5 0V3.75h3.5v.668a1.75 1.75 0 101.5 0V3.75h2.5V12a.75.75 0 001.5 0V3a.75.75 0 00-.75-.75H4zM7.75 6a.25.25 0 11.5 0 .25.25 0 01-.5 0zM13 5.75a.25.25 0 100 .5.25.25 0 000-.5zm4.75.25a.25.25 0 11.5 0 .25.25 0 01-.5 0zM23 5.75a.25.25 0 100 .5.25.25 0 000-.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.204 15.216a2.9 2.9 0 00-3.168.654l-8.761 8.76a.702.702 0 00-.183.322l-1.07 4.173a.7.7 0 00.853.853l4.173-1.07a.7.7 0 00.321-.184l7.542-7.541.008-.008.007-.008 1.204-1.203a2.9 2.9 0 00.025-4.117l-.002-.002a2.9 2.9 0 00-.949-.63zm-.78 4.473l.724-.725a1.5 1.5 0 00.015-2.127 1.5 1.5 0 00-2.128.015l-.006.006-.718.718 2.112 2.113zm-3.104-1.122l-6.234 6.234 2.115 2.11 6.232-6.232-2.113-2.112zm-7.647 9.76l.604-2.355 1.753 1.75-2.357.605z",
  fill: "currentColor"
})));